
export class IframeMessaging {
    iframeSelector = "#iframe";
    iframeUrl = "*"; 
    parentUrl = "*";

    sendToChild(type: string, message: any) {
        const iframe = document.querySelector<HTMLIFrameElement>(this.iframeSelector);

        if (iframe && iframe.contentWindow) {
            // envoyer un message à l'iframe
            iframe.contentWindow.postMessage(
                {
                    type: type,
                    message: message
                },
                this.iframeUrl // cible sécurisée
            );
        }
    }

    sendToParent(type: string, message: any) {

        // event.origin côté parent doit correspondre à ce domaine
        console.log('send to parent');
        window.parent.postMessage({
            type: type,
            message: message
        }, this.parentUrl);
    }

    listenChild(callback: (data: any) => void) {
        // écouter les messages venant de l'iframe
        window.addEventListener('message', (event) => {
            console.log(event);
            if (event.origin !== this.iframeUrl) return;
            callback(event.data);
        });
    }

    listenParent(callback: (data: any) => void) {
        // écouter les messages venant de l'iframe
        window.addEventListener('message', (event) => {
            if (event.origin !== this.parentUrl) return;
            callback(event.data);
        });
    }
}
